import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { ShoppingCart, Check } from 'lucide-react';
import { Product } from '../../data/products';
interface ProductDetailHeroProps {
  product: Product;
}
export function ProductDetailHero({
  product
}: ProductDetailHeroProps) {
  const [selectedSize, setSelectedSize] = useState(product.sizes?.[2] || '');
  const [selectedColor, setSelectedColor] = useState(product.colors?.[0] || '');
  const [quantity, setQuantity] = useState(1);
  return <section className="py-16 bg-white" data-id="element-584">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-585">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-586">
          {/* Product Image */}
          <div className="aspect-square rounded-xl overflow-hidden bg-slate-100" data-id="element-587">
            <img src={product.image} alt={product.name} className="w-full h-full object-cover" data-id="element-588" />
          </div>

          {/* Product Details */}
          <div data-id="element-589">
            <h1 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-4" data-id="element-590">
              {product.name}
            </h1>

            <div className="text-3xl font-bold text-[#dc2626] mb-6" data-id="element-591">
              ${product.price}
            </div>

            <p className="text-slate-600 mb-8" data-id="element-592">{product.description}</p>

            {/* Color Selection */}
            {product.colors && <div className="mb-6" data-id="element-593">
                <label className="block text-sm font-medium text-slate-700 mb-3" data-id="element-594">
                  Color
                </label>
                <div className="flex gap-3" data-id="element-595">
                  {product.colors.map(color => <button key={color} onClick={() => setSelectedColor(color)} className={`px-4 py-2 rounded-lg border-2 transition-all ${selectedColor === color ? 'border-blue-600 bg-blue-50 text-blue-600' : 'border-slate-200 hover:border-slate-300'}`} data-id="element-596">
                      {color}
                    </button>)}
                </div>
              </div>}

            {/* Size Selection */}
            {product.sizes && <div className="mb-6" data-id="element-597">
                <label className="block text-sm font-medium text-slate-700 mb-3" data-id="element-598">
                  Size
                </label>
                <div className="flex gap-3" data-id="element-599">
                  {product.sizes.map(size => <button key={size} onClick={() => setSelectedSize(size)} className={`px-4 py-2 rounded-lg border-2 transition-all min-w-[60px] ${selectedSize === size ? 'border-blue-600 bg-blue-50 text-blue-600' : 'border-slate-200 hover:border-slate-300'}`} data-id="element-600">
                      {size}
                    </button>)}
                </div>
              </div>}

            {/* Quantity */}
            <div className="mb-8" data-id="element-601">
              <label className="block text-sm font-medium text-slate-700 mb-3" data-id="element-602">
                Quantity
              </label>
              <div className="flex items-center gap-3" data-id="element-603">
                <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="w-10 h-10 rounded-lg border-2 border-slate-200 hover:border-slate-300 flex items-center justify-center font-medium" data-id="element-604">
                  −
                </button>
                <span className="w-12 text-center font-medium" data-id="element-605">{quantity}</span>
                <button onClick={() => setQuantity(quantity + 1)} className="w-10 h-10 rounded-lg border-2 border-slate-200 hover:border-slate-300 flex items-center justify-center font-medium" data-id="element-606">
                  +
                </button>
              </div>
            </div>

            {/* Add to Cart Button */}
            <Button variant="primary" size="lg" className="w-full mb-4" data-id="element-607">
              <ShoppingCart className="h-5 w-5 mr-2" data-id="element-608" />
              Add to Cart
            </Button>

            {/* Features */}
            {product.features && <div className="mt-8 pt-8 border-t border-slate-200" data-id="element-609">
                <h3 className="text-lg font-bold text-[#1a2332] mb-4" data-id="element-610">
                  Features
                </h3>
                <ul className="space-y-3" data-id="element-611">
                  {product.features.map((feature, index) => <li key={index} className="flex items-start text-slate-600" data-id="element-612">
                      <Check className="h-5 w-5 text-[#dc2626] mr-2 flex-shrink-0 mt-0.5" data-id="element-613" />
                      {feature}
                    </li>)}
                </ul>
              </div>}
          </div>
        </div>
      </div>
    </section>;
}